import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { PsoBaseButtonComponent } from '@app/@pso-ui/button-pso/pso-base-button.component';
import { PsoColor } from '@app/@wchfs-ui/lib/colors/colors.model';

@Component({
  selector: 'button[pso-outline-button]',
  templateUrl: './pso-outline-button.component.html',
  styleUrls: ['../pso-base-button.component.scss', './pso-outline-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PsoOutlineButtonComponent extends PsoBaseButtonComponent {
  @HostBinding('style.backgroundColor')
  get styleBackgroundColor(): string {
    return this.disabled ? `var(--ui-g5-gray5)` : 'transparent';
  }

  @HostBinding('style.color')
  get styleColor(): string {
    return this.disabled ? `var(--primary-w-white)` : `var(--${this.textColor})`;
  }

  @Input()
  textColor: PsoColor = 'primary-b-blue';
}
